/* RIM RED-347 (#MS-11): timing, lift above the footer's bottom row, pop-up open/close.
   Settings come from data attributes set in the theme editor (sections/rim-signup-tab.liquid).
   CM-55: trigger is 50% scroll depth OR 20 s on site, whichever first; auto-open once per session;
   no auto-open on a product page at mobile width (a bottom sheet there would cover the variant picker / Add to cart). */
(function () {
  var tab = document.querySelector('[data-rim-tab]');
  var pop = document.querySelector('[data-rim-pop]');
  if (!tab || !pop) return;
  if (/^\/(cart|checkout|account|password)(\/|$)/.test(location.pathname)) return;
  function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }
  var secs = +tab.dataset.seconds || 45, viewsN = +tab.dataset.views || 0, days = +tab.dataset.days || 14, scrollPct = +tab.dataset.scroll || 0;
  var auto = tab.dataset.auto === 'true', KEY = 'rim_tab_hide_until', shown = false, timer = null;
  function hidden() { var t = +ls(KEY); return !!t && Date.now() < t; }
  function hideFor() { ls(KEY, String(Date.now() + days * 864e5)); }
  function hideTab() { tab.classList.remove('is-visible'); tab.hidden = true; clearInterval(timer); }
  /* CM-69 (GREEN-178): the buying flow is no place for the offer. While the cart notification (or a cart drawer) is open the
     triggers wait (the visible-seconds count keeps adding up; the tab comes in once it closes) and rim-signup-tab.css hides a tab already showing. */
  function cartOpen() { return !!document.querySelector('#cart-notification.active, cart-drawer.active'); }

  /* time on site across pages (visible time, summed in sessionStorage); storage failure = this page only */
  var acc = +ss('rim_tab_secs') || 0, start = document.visibilityState === 'visible' ? Date.now() : null;
  function elapsed() { return acc + (start ? (Date.now() - start) / 1000 : 0); }
  function save() { ss('rim_tab_secs', String(Math.round(elapsed()))); }
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') { acc = elapsed(); start = null; save(); } else { start = Date.now(); }
  });
  addEventListener('pagehide', save);
  var views = (+ss('rim_tab_views') || 0) + 1; ss('rim_tab_views', String(views));

  /* lift: sit 16px above the footer bottom row's top border while that row is in view */
  var row = document.querySelector('.footer__content-bottom'), ticking = false;
  function lift() {
    var b = 24;
    if (row) { var r = row.getBoundingClientRect(); if (r.top < innerHeight && r.bottom > 0) b = Math.max(24, innerHeight - r.top + 16); }
    tab.style.setProperty('--rim-tab-bottom', b + 'px');
  }
  addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(function () { ticking = false; lift(); }); } }, { passive: true });
  addEventListener('resize', lift);
  if (row && 'IntersectionObserver' in window) new IntersectionObserver(lift).observe(row);

  function openPop() { if (!pop.open) pop.showModal(); }
  /* CM-55: auto-open at most once per session; never over the product form on mobile */
  function autoOpen() {
    if (ss('rim_pop_auto_done')) return;
    if (/^\/products\//.test(location.pathname) && matchMedia('(max-width: 749px)').matches) return;
    ss('rim_pop_auto_done', '1');
    openPop();
  }
  function show(why) {
    if (shown || hidden() || cartOpen()) return;
    shown = true; lift(); tab.hidden = false;
    tab.dataset.trigger = why || 'time';
    requestAnimationFrame(function () { tab.classList.add('is-visible'); });
    if (auto) autoOpen();
  }

  tab.querySelector('[data-rim-open]').addEventListener('click', openPop);
  tab.querySelector('[data-rim-dismiss]').addEventListener('click', function () { hideFor(); hideTab(); });
  pop.querySelector('[data-rim-close]').addEventListener('click', function () { pop.close(); });
  var no = pop.querySelector('[data-rim-no]');
  if (no) no.addEventListener('click', function () { hideFor(); hideTab(); pop.close(); });
  pop.addEventListener('click', function (e) { if (e.target === pop) pop.close(); });

  /* back from the footer sign-up: counts as signed up, so no tab */
  if (location.hash === '#ContactFooter' && document.getElementById('ContactFooter-success')) { hideFor(); return; }

  /* back from a sign-up POST: Shopify returns to /...#RimPopupForm */
  if (location.hash === '#RimPopupForm') {
    if (pop.querySelector('[data-rim-ok]')) hideFor();
    shown = true; if (!pop.querySelector('[data-rim-ok]')) { tab.hidden = false; tab.classList.add('is-visible'); lift(); }
    openPop(); return;
  }
  if (window.Shopify && Shopify.designMode) { show(); return; }
  if (hidden()) return;
  if (viewsN && views >= viewsN) setTimeout(show, 1500);
  timer = setInterval(function () { if (elapsed() >= secs && !cartOpen()) { clearInterval(timer); show('time'); } }, 1000);

  /* CM-55: scroll depth = how far down the scrollable page the bottom of the viewport has travelled */
  if (scrollPct) {
    var onDepth = function () {
      var h = document.documentElement.scrollHeight - innerHeight;
      if (h <= 0) return;
      if (scrollY / h * 100 >= scrollPct && !cartOpen()) {
        removeEventListener('scroll', onDepth);
        clearInterval(timer);
        show('scroll');
      }
    };
    addEventListener('scroll', onDepth, { passive: true });
  }
}());